/**
 * Where a Bobcat AI route (`/ai/*`) is served: the admin backend's
 * `/rest/bobcat`, like every other `/rest/*` call here (pypestream/backend#1457
 * moved the routes off Pro Studio's own functions, PSTUDIO-4629). The call is
 * cross-origin, so it must send `credentials: 'include'` for the Kratos
 * cookie, and the backend only answers origins it allows.
 */
export const bobcatApiUrl = (path: string): string =>
  `${import.meta.env.FE_ADMIN_URL}/rest/bobcat${path}`;

/**
 * Where Test View's own routes (`/test/*`, the run trace) are served: the
 * same backend, under `/rest/bobcat/test`, behind the same cookie
 * (PSTUDIO-4682). Spread into `@pypestream/testview`'s calls.
 */
export const testViewApi = () => ({
  apiPrefix: bobcatApiUrl('/test'),
  credentials: 'include' as const,
});
